import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getRenderListData = (showFullList, showExpandCta, data, initialItemCount) => {
  var renderedListData = showFullList || !showExpandCta ? data : data.slice(0, Math.min(data.length, initialItemCount));
  return renderedListData ? renderedListData : [];
};
export var getPlanListWidgetStyles = isLargeScreen => {
  var spacing = tokens.spacing;
  return StyleSheet.create({
    packCard: {
      marginBottom: isLargeScreen ? spacing.SPACING_24 : spacing.SPACING_16
    },
    calloutStyle: {
      marginBottom: spacing.SPACING_16
    }
  });
};